import { useTranslation } from 'react-i18next';
import { enablePush, getPushPermissionState } from '../../lib/fcm';

/**
 * Outline banner on the Today screen that nudges drivers to enable push
 * notifications. Renders only when the browser permission state is
 * 'default' (i.e., user has neither granted nor denied yet). Hidden the
 * moment permission flips to granted, denied, or when push is unsupported.
 *
 * Tapping "Turn on" calls enablePush() directly — no modal indirection.
 * On success the component re-renders, sees permission='granted', and
 * returns null (vanishes from the layout).
 */
export function PushEnableCard() {
  const { t } = useTranslation('common');
  const state = getPushPermissionState();
  if (state !== 'default') return null;

  // Outer padding comes from TodayRoute's <div className="px-5 pt-2 pb-10"> —
  // we don't add mx-* here. Just vertical spacing to separate from the trip list.
  return (
    <div
      className="mt-2 mb-3 flex items-center gap-3 rounded-2xl border border-[var(--color-border,#d1d5db)] bg-[var(--color-surface)] px-4 py-3"
      data-testid="push-enable-card"
    >
      <BellIcon />
      <p className="flex-1 text-sm text-[var(--color-text)]">
        {t('push.card.body', { defaultValue: 'Turn on notifications to get new trip alerts' })}
      </p>
      <button
        type="button"
        onClick={() => { void enablePush(); }}
        className="rounded-full bg-[var(--color-btn-primary,#1B6A41)] px-4 py-1.5 text-sm font-medium text-white"
      >
        {t('push.card.enable', { defaultValue: 'Turn on' })}
      </button>
    </div>
  );
}

function BellIcon() {
  return (
    <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}
